import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

let columns = document.querySelectorAll('.slider-columns > div');

for (var i = columns.length - 1; i >= 0; i--) {

    let bkgd = columns[i].querySelector('.slider-columns-bg');
    let settings = {
        trigger: '.slider-columns-trigger',
        // start: "-100%",
        end: "-=10%",
        scrub: true,
        markers: false,
        ease: 'sine.inOut',
        delay: 0.75,
        duration: 1.5,
    };

    var tl = gsap.timeline({
         scrollTrigger: {
            trigger: settings.trigger,
            start: settings.start,
            end: settings.end,
            scrub: settings.scrub,
            markers: settings.markers
        }
    });

    tl.fromTo(columns[i],
        {
            y: 200,
            opacity: 0,
            ease: settings.ease,
            delay: settings.delay * i,
            duration: settings.duration,
        },
        {
            y: 0,
            opacity: 1,
            ease: settings.ease,
            delay: settings.delay * i,
            duration: settings.duration,
        }
    );
};